module.exports = __webpack_public_path__ + "img/icon-individual.f267bd2.svg";